<kendo-card class="card-container">
  <form [formGroup]="form" class="form">
    <kendo-gridlayout [rows]="[{height:40},{height:40},{height:40}]" [cols]="[{width:110},{width:320}]" [gap]="{rows:0, cols:40}">

      <kendo-gridlayout-item [row]="1" [col]="1" [colSpan]="1">
        <kendo-label>Available Item(s) *</kendo-label>
      </kendo-gridlayout-item>
      <kendo-gridlayout-item [row]="1" [col]="2" [colSpan]="1">
        <app-select-field [control]="availableItems" formControlName="availableItems"></app-select-field>
      </kendo-gridlayout-item>

    </kendo-gridlayout>
  </form>

  <div class="submitSection">
    <button kendoButton class="btnSave" [disabled]="!form.valid || saving" (click)="save()">
      @if (saving){
      <kendo-loader type="pulsing" size="medium" themeColor="warning"></kendo-loader>
      } @else {
      <span id="iconContainer" style="display:block;float:left"><fa-icon #icon [icon]="saveIcon"></fa-icon></span>
      }
      &nbsp;&nbsp;
      Save
    </button>
  </div>

</kendo-card>
